<div class="charity-section">
    <!-- <h2 class="heading">Would you like to leave a Bequest?</h2>
    <p class="subheading">
      Leaving a bequest is a lasting and loving act that allows you to extend your values and make a difference beyond your lifetime. By including charities in your legacy, you ensure that your generosity continues to impact others for years to come.
    </p> -->
  
    <h3 class="explore-title">Choose the Charities You Wish to Support in Your Will</h3>

    <ng-container *ngIf="charityLoading">
    <div class="large-card-skeleton d-flex flex-wrap p-3 mb-4 border rounded">
      <div class="skeleton" style="width: 120px; height: 120px; border-radius: 8px;"></div>
    
      <div class="flex-grow-1 ps-3 d-flex flex-column justify-content-between">
        <div>
          <div class="skeleton" style="height: 24px; width: 50%; margin-bottom: 12px;"></div>
          <div class="skeleton" style="height: 16px; width: 30%; margin-bottom: 8px;"></div>
          <div class="skeleton" style="height: 48px; width: 100%; margin-bottom: 12px;"></div>
        </div>
        <div class="d-flex gap-2">
          <div class="skeleton" style="height: 36px; width: 36px; border-radius: 50%;"></div>
          <div class="skeleton" style="height: 36px; width: 36px; border-radius: 50%;"></div>
        </div>
      </div>
    
    </div>

    <div class="row gx-3 gy-4">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="small-card-skeleton p-3 border rounded">
          <div class="skeleton mb-2" style="height: 120px; border-radius: 8px;"></div>
          <div class="skeleton mb-2" style="height: 16px; width: 80%;"></div>
          <div class="skeleton mb-2" style="height: 16px; width: 60%;"></div>
          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="skeleton" style="height: 36px; width: 100px; border-radius: 20px;"></div>
            <div class="skeleton" style="height: 36px; width: 36px; border-radius: 50%;"></div>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
  
    <!-- Featured Charity -->
    <ng-container  *ngIf="!charityLoading">
    <div class="featured-card"  [ngClass]="{'selectedCharity': isCharitySelected(featuredCharity?.orgId)}">

      <div class="featured-mobile-card-image">
        <img class="bnImgMobile" [src]="featuredCharity?.orgBannerImage" alt="Image"  alt="Charity Image" />
        <!-- <img class="logoImgMobile" [src]="featuredCharity?.orgLogo" width="185" height="99" alt="Logo" alt="Logo" /> -->
      </div>
      
      <!-- <div class="featured-logo">
        <img [src]="featuredCharity?.orgLogo" width="85" height="85" alt="Logo" />
      </div> -->
      <div class="featured-details">
        <div class="wrap-large-card">  
          <div class="featured-logo">
            <img [src]="featuredCharity?.orgLogo ? featuredCharity.orgLogo : '../../../../assets/images/no_Image_Available.jpg'" width="85" height="85" alt="Logo" />
          </div>
          <div>
            <div class="name">{{ featuredCharity?.orgName }}</div>
            <div class="categoryNameClass">
              {{ featuredCharity?.categoryName?.length > 25 
                ? (featuredCharity.categoryName | slice:0:25) + '...' 
                : featuredCharity?.categoryName }}
            </div>
            <!-- <div class="category-badge"  [ngStyle]="{ 'background': featuredCharity?.categoryColour }"><img [src]="featuredCharity?.categoryIcon" width="36" height="36" alt="Logo" /> {{ featuredCharity?.categoryName?.length > 25 
                ? (featuredCharity.categoryName | slice:0:25) + '...' 
                : featuredCharity?.categoryName }}</div> -->
          </div>
        </div>
        <div class="location" [title]="(featuredCharity?.orgCity || '') + ', ' + (featuredCharity?.orgState || '')">{{ featuredCharity?.orgCity }}, {{featuredCharity?.orgState}}</div>
        <!-- <div class="description fs" [innerHTML]="featuredCharity?.orgParternshipDescription"> -->
          <!-- {{ featuredCharity?.orgParternshipDescription }} -->
        <!-- </div> -->
        <div class="charity-desc-container">
          <div class="charity-description fs" [class.clamped]="!expanded && showToggle" [class.expanded]="expanded"
            #charityDescEl [innerHTML]="featuredCharity?.orgParternshipDescription || ''">
          </div>
          <button *ngIf="showToggle" class="charity-toggle-btn" [innerHTML]="expanded ? 'Read Less' : 'Read More'"
            (click)="toggleExpansion()">
          </button>
        </div>
        <div class="btn-contr">
        <button *ngIf="!isCharitySelected(featuredCharity?.orgId)" class="gift-btn" (click)="giftCharityFromCard(featuredCharity)">Gift this Charity</button>
        <img height="35" *ngIf="isCharitySelected(featuredCharity?.orgId)" src="../../../../assets/images/tick-icon.svg">&nbsp;
        <!-- <button class="info-button" (click)="openCharityDetail('xl')"><img src="../../../../assets/images/info-icon.svg"></button> -->
        <button (click)="openCharityDetail('xl')" class="info-circle-button">i</button>
        </div>
      </div>
      <div class="featured-image">
        <img [src]="featuredCharity?.orgBannerImage ? featuredCharity?.orgBannerImage : '../../../../assets/images/no-img.png'" alt="Image" />
      </div>
      
    </div>
  
    <!-- Charity Cards Grid -->
    <div class="charity-grid">
      <!-- <div class="charity-card" *ngFor="let charity of charities">
        <img class="card-image" [src]="charity.image" alt="Charity" />
        <div class="card-content">
          <img class="card-logo" [src]="charity.logo" alt="Logo" />
          <div class="category-badge"><img [src]="featuredCharity.categoryLogo" alt="Logo" />  {{ charity.category }}</div>
          <div class="name">{{ charity.name }}</div>
          <div class="view-more">View More ></div>
        </div>
      </div> -->
      <!-- <ng-container *ngFor="let charity of custCharityCardData">
        <div class="charity-card"  [ngClass]="{'selectedCharity': isCharitySelected(charity?.customCharityId || charity?.orgId)}" >
        <div class="card-image">
          <img *ngIf="charity?.orgBannerImage" [src]="charity?.orgBannerImage" alt="Charity Image" />
          <img *ngIf="charity?.orgLogo" class="logo" [src]="charity?.orgLogo" alt="Logo" />
          <div  class="category-badge"  [ngStyle]="{ 'background': charity.categoryColour }">
           <ng-container *ngIf="charity.categoryIcon"><img [src]="charity?.categoryIcon" alt="Icon" /></ng-container> 
            
             <span [title]="charity?.categoryName" >{{ charity?.categoryName?.length > 19 
              ? (charity.categoryName | slice:0:19) + '...' 
              : charity?.categoryName }}</span>
          </div>
        </div>
        <div class="card-title" [title]="charity?.orgName">{{charity?.orgName }}</div>
        <div class="charity-action">
        <button *ngIf="!isCharitySelected(charity?.customCharityId || charity?.orgId)" class="gift-btn">Gift this Charity</button>
        <img *ngIf="isCharitySelected(charity?.customCharityId || charity?.orgId)" src="../../../../assets/images/tick-icon.svg">
        <button  class="info-circle-button">i</button>
  
         </div>
      </div>

      </ng-container> -->

      <!-- Add Another Charity -->
      <div *ngIf="!isView" class="charity-card add-another" (click)="openCharityDetail('lg',true)">
        <div class="plus"><img width="28" height="28" src="../../../../assets/images/plus-primary.svg"></div><br>
        <div class="add-label">Add Another Charity</div>
      </div>
      
      <ng-container *ngFor="let charity of charities">
      <div class="charity-card"  [ngClass]="{'selectedCharity': isCharitySelected(charity?.customCharityId || charity?.orgId)}" >
        <div class="card-image">
          <img *ngIf="charity?.orgBannerImage" [src]="charity?.orgBannerImage" alt="Charity Image" />
          <img *ngIf="charity?.orgLogo" class="logo" [src]="charity?.orgLogo" alt="Logo" />
          <!-- <div  class="category-badge"  [ngStyle]="{ 'background': charity.categoryColour }">
           <ng-container *ngIf="charity.categoryIcon"><img [src]="charity?.categoryIcon" alt="Icon" /></ng-container> 
             <span [title]="charity?.orgName" >{{ charity?.categoryName?.length > 19 
              ? (charity.categoryName | slice:0:19) + '...' 
              : charity?.categoryName }}</span>
          </div> -->
        </div>
        <div class="card-title" [title]="charity?.orgName">{{charity?.orgName}}</div>
        <div class="categoryNameClassSmallCard">
            <span [title]="charity?.orgName" >{{ charity?.categoryName?.length > 19 
              ? (charity.categoryName | slice:0:19) + '...' 
              : charity?.categoryName }}</span>
          </div>
        <div class="charity-action">
        <button *ngIf="!isCharitySelected(charity?.customCharityId || charity?.orgId)" class="gift-btn" (click)="giftCharityFromCard(charity)">Gift this Charity</button>
        <img *ngIf="isCharitySelected(charity?.customCharityId || charity?.orgId)" src="../../../../assets/images/tick-icon.svg">
        <button (click)="openCharityDetail('lg',false,charity)" class="info-circle-button">i</button>
         <!-- <button class="info-button" (click)="openCharityDetail('lg',false,charity)"><img src="../../../../assets/images/info-icon.svg"></button> -->
         </div>
      </div>
      </ng-container>
  
      
    </div>
  
    <ng-container *ngIf="loadingMoreCharity">
    <div class="row gx-3 gy-4">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let i of [1,2,3]">
        <div class="small-card-skeleton p-3 border rounded">
          <div class="skeleton mb-2" style="height: 120px; border-radius: 8px;"></div>
          <div class="skeleton mb-2" style="height: 16px; width: 80%;"></div>
          <div class="skeleton mb-2" style="height: 16px; width: 60%;"></div>
          <div class="d-flex justify-content-between align-items-center mt-3">
            <div class="skeleton" style="height: 36px; width: 100px; border-radius: 20px;"></div>
            <div class="skeleton" style="height: 36px; width: 36px; border-radius: 50%;"></div>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
    <button class="load-more" *ngIf="showLoadMoreButton && !loadingMoreCharity" (click)="loadMore()"><img width="14" height="14" src="../../../../assets/images/plus-primary.svg">&nbsp;Load More</button>
  </ng-container>
  </div>

  <button class="btn btn-primary" style="display: none;" #openChartityModalButton data-bs-toggle="modal" data-bs-target="#charityDetailModal">
    View Charity Detail
  </button>
  

  
  <!-- Modal -->
  <div class="modal fade" id="charityDetailModal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="charityDetailModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" [ngClass]="modalSizeClass">
      <div class="modal-content view-more-modal rounded-4">
  
        <!-- Close Button -->
        <button type="button" (click)="modalCanceled()" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>
  
        <!-- Charity Detail Component -->
        <div class="charity-detail-card" *ngIf="!addAnotherCharityActive">
            <div class="image-container" [ngClass]="{'largeCard': modalSizeClass=='modal-xl'} ">
              <img *ngIf="!charity.coverImage" class="cover-image" src="../../../../assets/images/no-img.png">
              <img *ngIf="charity.coverImage" [src]="charity.coverImage" alt="Charity Cover" class="cover-image" />
              <img *ngIf="charity.logo"  [src]="charity.logo" alt="Charity Logo" class="charity-logo" />
              <!-- <div class="category-badge" [ngStyle]="{ 'background': charity.color }">
                <img *ngIf="charity.categoryIcon" [src]="charity.categoryIcon" alt="icon" />
                {{ charity.category }}
              </div> -->
            </div>
      
            <div class="charity-info">
              <h2 class="charity-name">{{ charity.name }}</h2>
              <div class="categoryNameClass">
                {{ charity.category }}
              </div>
              <div class="ein-and-description">
              <p class="location">{{ charity.location }}</p>
              <p class="ein" *ngIf="charity.ein">EIN: {{ charity.ein }}</p>
            </div>
                <p class="description fs"  [innerHtml]="charity.description"></p>
              <div class="about-box" *ngIf="modalSizeClass=='modal-xl'">
                <p class="about-title">About Us</p>
                <p class="about-text fs" [innerHtml]="charity.about"></p>
              </div>
      
              <a [href]="formatUrl(charity.website)" class="charity-link" target="_blank">{{ charity.website }}</a><br>
              <!-- <div class="btn-cntr">
              <button class="gift-btn" (click)="sendData()" data-bs-dismiss="modal" aria-label="Close">Gift this Charity</button>
              </div> -->
            </div>
          </div>

          <div class="addAnotherCharity" *ngIf="addAnotherCharityActive">
              <div class="form-wrapper">
                <h3>Add New Charity</h3><br>
                <form [formGroup]="charityForm" (ngSubmit)="onSubmit()">
                  <label>
                    <div class="label-container">Charity Name<span class="required">*</span></div>
                    <div class="search-bar">
                      <input formControlName="charityName" [formControl]="searchControl" [(ngModel)]="searchText"
                        (input)="onSearchInput($event)" placeholder="Start typing to search or enter a new charity name"
                        class="form-control" />
                      </div>
                      
                      <ul class="dropdown-list" *ngIf="(favCharityNameList.length || showNoResult || searching) && searchText"
                        (scroll)="onDropdownScroll($event)">
                        <ng-container *ngIf="searching">
                          <li class="skeleton-item" *ngFor="let s of [1,2,3]"></li>
                        </ng-container>
                        <li *ngFor="let option of favCharityNameList" (click)="selectCharityOption($event, option)">
                          {{ option.orgName }} <br>
                          <span style="font-size: 15px;">
                            {{option?.orgCity}}, {{option?.orgState}}
                            &nbsp; <ng-container *ngIf="option?.orgEinNumber"> EIN: {{option?.orgEinNumber}}</ng-container>
                          </span>
                        </li>
                        <li *ngIf="loading" class="loading-option">
                          Loading...
                        </li>
                        <li *ngIf="showNoResult && !searching" class="no-result-option" (click)="closeDropdown()">
                          No matching charity found. Please enter the details manually to proceed.
                        </li>
                      </ul>
                      </label>
                  
                  <label>
                    <div class="label-container">Organization Type<span class="required">*</span></div>
                    <ng-select id="organizationType"
                    formControlName="organizationType" (click)="closeDropdown()" [searchable]="false" placeholder="Select">
                    <ng-option
                        *ngFor="let option of charityCategoryList" [value]="option">{{option.name}}</ng-option>
                  </ng-select>
                  </label>
                  
                  <label>
                    <div class="label-container">City<span class="required">*</span></div>
                    <input id="city"
                    formControlName="city" (click)="closeDropdown()" (input)="preventSpaceInInput($event)" [searchable]="false" placeholder="City">
                  
                  </label>
            
                  <label>
                    <div class="label-container">State<span class="required">*</span></div>
                    <input id="state"
                    formControlName="state" (input)="preventSpaceInInput($event)" (click)="closeDropdown()" [searchable]="false" placeholder="State">
                  </label>

                  <br>
            
                  <button class="add-charity" type="submit" [disabled]="!this.charityForm.valid" data-bs-dismiss="modal" aria-label="Close">Add Charity</button>
                </form>
              </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer" *ngIf="!addAnotherCharityActive">
            <div class="right-btn-container">
              <button *ngIf="!isCharitySelected(charity?.orgId)" class="gift-btn"
                (click)="giftCharityClicked()">Gift this Charity</button>
              <img height="35" *ngIf="isCharitySelected(charity?.orgId)"
                src="../../../../assets/images/tick-icon.svg">&nbsp;
            </div>
          </div>
      </div>
    </div>
  </div>
  
